<template>
  <v-dialog v-model="dialogPackageDetail" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title v-if="currentItem.ID > 0">Chi tiết lô hàng #{{currentItem.ID}}</v-toolbar-title>
        <v-toolbar-title v-else>Tạo mới lô hàng</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap pl-5>
              <v-flex lg6 md6 sm12 pa-2>
                <v-text-field
                  label="Mã lô hàng"
                  v-model="currentItem.PackageCode"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-2>
                  <v-select v-model="currentItem.Status" :items="bigpackage_status" item-text="name" item-value="value" label="Trạng thái" class="input-group--focused"></v-select>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-2>
                <h-currency-input
                  label="Tổng kiện hàng"
                  v-model="currentItem.NumberOfPack"
                  :decimal="0"
                  class="input-group--focused"
                  disabled
                ></h-currency-input>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-2>
                <h-currency-input
                  label="Tổng mã"
                  v-model="currentItem.TotalCode"
                  :decimal="0"
                  class="input-group--focused"
                  disabled
                ></h-currency-input>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 ma-0 >
                <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã kiện"
                  ref="trancode"
                  v-model="currentTransaction.TransactionCode"
                  class="input-group--focused"
                  @input="codeChanged"
                  @keyup.enter="manualChanged"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-data-table
                  :headers="headers"
                  :items="currentItem.Packages"
                  :server-items-length="currentItem.Packages.length"
                  :options.sync="pagination"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.TransactionCode }}</td>
                      <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                      <td v-bind:style="{ 'color': text_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                      <td>{{ item.StoreCNImportDate | display_date }}</td>
                      <td>{{ item.CustomsDate | display_date }}</td>
                      <td>{{ item.StoreVNImportDate | display_date }}</td>
                      <td class="text-center" v-if="userRole > 0">
                        <v-icon medium @click="deleteItem(item)" class="pa-2">delete</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1 white--text" @click="closePopup">Đóng</v-btn>
        <v-btn color="blue darken-1 white--text" @click="exportData(currentItem.ID)">Xuất file</v-btn>
        <v-btn color="blue darken-1 white--text" @click="saveItem">Lưu lại</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Vue from 'vue';
import _ from "lodash";
import moment from "moment";
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { request_list } from '@/commons/hpod';

export default {
  name: "big-package-popup",
  data() {
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 1000000;
    return {
      useBarcodeReader: true,
      currentTransaction: {
        TransactionCode: ""
      },
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [10] },
      currentTime: getCurrentTime(),
      bigpackage_status_type: configs.BIGPACKAGE_STATUS_TYPE,
      bigpackage_status: configs.BIGPACKAGE_STATUS,
      shipping_methods: configs.SHIPPING_METHOD,
      product_types: configs.PRODUCT_TYPE,
      package_status: configs.PACKAGE_STATUS,
      oldItem: {}
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    dialogPackageDetail() {
      if (this.dialogPackageDetail) {
        if(this.userRole !== 0){
          this.$nextTick(() => this.$refs.trancode.focus());
        }
      }
    }, 
    currentItem() {
      this.oldItem = {...this.currentItem};
    }
  },
  computed: {
    ...mapState({
      customers: state => state.customer.all.data,
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading,
      configuration: state => state.configuration.hpoConfig
    }),
    selectedCustomer() {
      return _.find(this.customers, {'ID': this.currentItem.UID});
    },
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      var temp = [
        {
          text: "Mã kiện",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Nhập kho TQ",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Thông quan",
          value: "CustomsDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Nhập kho VN",
          value: "StoreVNImportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Thao tác",
          align: "center",
        }
      ];
      return temp;
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    filter_data: function() {
      if (this.currentItem.ID > 0) {
        var param = {
          pagination: this.pagination
        };
        this.$store.dispatch("bigPackage/getDetail", {'id': this.currentItem.ID, 'param': param});
      }
    },
    updateItemDetail() {
      this.currentItem.NumberOfPack = this.currentItem.Packages.length;
      this.currentItem.Weight =  _.sumBy(this.currentItem.Packages, 'Weight');
      this.currentItem.Volume =  _.sumBy(this.currentItem.Packages, 'Volume');
      this.currentItem.Amount =  _.sumBy(this.currentItem.Packages, 'FeeShipVND') + _.sumBy(this.currentItem.Packages, 'FeeShipCNVN') + _.sumBy(this.currentItem.Packages, 'FeeOther');
    },
    deleteTransaction(id) {
      _.remove(this.currentItem.Packages, pkg => pkg.ID === id);
      this.updateItemDetail();
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    savePackageItem(item) {
      this.$store.dispatch("storeManager/setDetail", {
        'data': item,
        'id': item.ID,
        'bigPackageId': this.currentItem.ID
      });
    },
    saveItem() {
      this.updateItemDetail();
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ...this.currentItem,
          'Packages': _.map(this.currentItem.Packages, "ID")
        },
        id: this.currentItem.ID
      });
      this.$emit("closeSavePopup");
    },
    manualChanged() {
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
        let param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode,
                condition: "s_equal"
            }]
        };
        const checkTran = _.find(this.currentItem.Packages, {TransactionCode: this.currentTransaction.TransactionCode})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Kiện hàng đã tồn tại.')
          return;
        }
        request_list('storemanager', ret => {
          if(ret.data.length > 0 && ret.data[0].BigPackageID == 0) {
            this.currentItem.Packages.unshift(ret.data[0]);
            this.updateItemDetail();
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else if(ret.data.length > 0 && ret.data[0].BigPackageID > 0) {
            sendErrorNotice('Kiện hàng đã đóng trong bao hàng khác.')
          }
          else {
            sendErrorNotice('Kiện hàng chưa có trong hệ thống.')
            // this.currentItem.Packages.unshift({
            //   ID: 0,
            //   BigPackageID: this.currentItem.ID,
            //   TransactionCode: this.currentTransaction.TransactionCode,
            // });
            // this.updateItemDetail();
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
          }
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    text_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    exportData(id) {
      var param = {
        filter: [{column: 'BigPackageID', value: id, condition: 'equal'}]
      };
      this.$store.dispatch("storeManager/export", param);
    },
    deleteItem(item) {
      const index = this.currentItem.Packages.indexOf(item);
      if (index > -1) { 
        this.currentItem.Packages.splice(index, 1); 
      }
    }
  },
  mounted() {
    this.$root.$on("CONFIRMED_REMOVE_DATA", () => {
      this.$emit("closePopup");
    });
  },
  beforeDestroy() {
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
